<template>
  <div class="position-relative cursor-pointer" @click="toggleDropdown">
    <div class="info d-flex align-items-center">
      <div class="selected-options-elements">
        <span class="title">
          {{ theme.charAt(0).toUpperCase() + theme.slice(1) }}:
          {{ selectedOptions.length === 0 ? `None selected` : "" }}
          {{
            selectedOptions.length == options.length &&
            selectedOptions.length > 1
              ? "All"
              : selectedOptions[0]?.label
          }}
        </span>
      </div>
      <div
        v-if="
          selectedOptions.length != options.length && selectedOptions.length > 1
        "
        class="counter ml-1 d-flex justify-content-center"
      >
        + {{ selectedOptions.length - 1 }}
      </div>
      <div class="icon ml-auto" @click="toggleDropdown">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          @click="toggleDropdown"
        >
          <path
            d="M5.34503 7.5L14.655 7.5C14.8198 7.50004 14.9809 7.54893 15.1179 7.6405C15.2549 7.73207 15.3617 7.86221 15.4248 8.01446C15.4878 8.16671 15.5043 8.33423 15.4722 8.49586C15.44 8.65749 15.3607 8.80596 15.2442 8.9225L10.5892 13.5775C10.4329 13.7337 10.221 13.8215 10 13.8215C9.77906 13.8215 9.56713 13.7337 9.41086 13.5775L4.75586 8.9225C4.63935 8.80595 4.56001 8.65748 4.52787 8.49586C4.49573 8.33423 4.51224 8.1667 4.5753 8.01445C4.63835 7.8622 4.74514 7.73207 4.88215 7.6405C5.01915 7.54893 5.18024 7.50004 5.34503 7.5Z"
            fill="#646A7A"
          />
        </svg>
      </div>
      <div ref="dropdownContainer" v-if="isDropdownOpen" class="overflow-box">
        <div class="item" v-if="!hideSearch">
          <b-form-input
            class="search-input"
            v-model="searchTerm"
            :placeholder="
              `Search ${theme.charAt(0).toUpperCase() + theme.slice(1)}`
            "
          ></b-form-input>
        </div>
        <b-form-group class="options">
          <b-form-checkbox
            v-if="localOptions.length !== 1 && !hideAllOption && !searchTerm"
            ref="selectAllCheckBox"
            @change="handleSelectAll"
            size="lg"
            class="enhanced-title"
            v-model="selectAll"
          >
            <span style="font-size: 14px;">All</span>
          </b-form-checkbox>
          <b-form-checkbox-group size="lg" v-model="selectedOptions" stacked>
            <b-form-checkbox
              v-for="(item, index) in localOptions"
              :key="index"
              :value="item"
            >
              <span style="font-size: 14px;">
                {{ item.label }}
              </span></b-form-checkbox
            >
          </b-form-checkbox-group>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: ["options", "theme", "width", "hideSearch", "hideAllOption", "value"],
  data() {
    return {
      isDropdownOpen: false,
      searchTerm: "",
      selectAll: false,
      localOptions: []
    };
  },
  mounted() {
    this.localOptions = this.options;
    this.selectAll =
      this.value.length == this.options.length && this.value.length > 0;
    document.addEventListener("click", this.clickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.clickOutside);
  },
  computed: {
    filteredOptions() {
      return this.options.filter(option =>
        option.label.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    },
    controlWidth() {
      return this.width ? `${this.width}px` : `251px`;
    },
    selectedOptions: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.selectAll = newValue.length == this.options.length;
        this.$emit("input", newValue);
      }
    }
  },
  methods: {
    toggleDropdown(event) {
      if (
        this.$el == event.target ||
        (this.$el.contains(event.target) &&
          (event.target.classList.contains("info") ||
            event.target.classList.contains("title") ||
            event.target.classList.contains("icon") ||
            event.target.tagName === "path" ||
            event.target.tagName === "svg" ||
            event.target.classList.contains("selected-options-elements")))
      ) {
        this.isDropdownOpen = !this.isDropdownOpen;
        this.searchTerm = "";
      }
    },
    clickOutside(event) {
      if (!(this.$el == event.target || this.$el.contains(event.target))) {
        this.isDropdownOpen = false;
      }
    },
    handleSelectAll(event) {
      if (event) {
        this.selectedOptions = this.localOptions;
      } else {
        this.selectedOptions = [];
      }
    }
  },
  watch: {
    searchTerm(value) {
      if (value) {
        this.localOptions = this.options.filter(item =>
          item.label.toLowerCase().includes(value.toLowerCase())
        );
      } else {
        this.localOptions = this.options;
      }
    },
    options(val) {
      this.localOptions = val;
    }
  }
});
</script>

<style scoped>
.info {
  width: v-bind(controlWidth);
  height: 45px;
  flex-shrink: 0;
  border-radius: 7px;
  background: var(--white, #ffffff);
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);
  font-family: Bahnschrift;
}

.title {
  color: #646a7a;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 14px 0 14px 12px;
}

.enhanced-title {
  color: #646a7a;
  text-align: justify;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Bahnschrift;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.25px;
}

.counter {
  width: 30px;
  height: 24px;
  height: var(--6, 24px);
  flex-shrink: 0;
  border-radius: 4px;
  background: #ededf4;
  box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.icon {
  flex-shrink: 0;
  margin: 0 13px 0 0;
  cursor: pointer;
}

.search-icon {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
}

.overflow-box {
  flex-direction: column;
  display: flex;
  width: v-bind(controlWidth);
  height: auto;
  position: absolute;
  top: 50px;
  background-color: lightblue;
  z-index: 99999; /* Ensure the box appears above other content */
  border-radius: 7px;
  background: var(--white, #fff);
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);
  overflow-y: auto;
  padding-top: var(--25, 10px);
  margin-top: 2px;
  max-height: 500px;
}

.item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: var(--2, 8px) var(--4, 16px);
  align-items: center;
  gap: 20px;
  align-self: stretch;
}

.options {
  display: flex;
  padding: var(--2, 8px) var(--4, 16px);
  align-items: center;
  gap: 20px;
  align-self: stretch;
}

/* Customize the scrollbar for WebKit browsers */
.overflow-box::-webkit-scrollbar {
  width: 2px; /* Set the width of the scrollbar */
}

.overflow-box::-webkit-scrollbar-thumb {
  background-color: #363abb; /* Set the color of the scrollbar thumb */
  border-radius: 6px; /* Round the edges of the thumb */
  border: 2px solid #363abb;
}

.overflow-box::-webkit-scrollbar-thumb:hover {
  background-color: #363abb; /* Change thumb color on hover */
}

.search-icon {
  background: #fbfbfb !important;
  fill: #363abb;
}

.selected-options-elements {
  max-width: 300px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
}
</style>
